import { FC, useState } from 'react';
import styled from 'styled-components';
import { Redirect, useParams, useLocation } from 'react-router-dom';
import Button from '../Button';
import DateToggle from './DateToggle';
import PlayerChartCard from './PlayerChartCard';
import { Chart } from './ButtonChart';

const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 16px;

  @media screen and (min-width: 540px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media screen and (min-width: 1024px) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media screen and (min-width: 1280px) {
    grid-template-columns: repeat(4, 1fr);
  }
`;
const CardContainer = styled.div`
  width: max(77%, 1120px);
  margin: 0 auto;
  padding: 52px 0 42px;
`;

const Title = styled.h2(({ theme }) => {
  const { color, type } = theme;

  return `
    font-size: ${type.size.larger};
    color: ${color.grayscale[0]};
    margin-bottom: 24px;
    font-weight: ${type.weight.bold};
  `;
});

const StyledDateToggle = styled(DateToggle)`
  margin-bottom: 11px;
`;

const NoMeasurements = styled.div(({ theme }) => {
  const { color, type } = theme;

  return `
    font-size: ${type.size.large};
    color: ${color.grayscale[0]};
    text-align: center;
    grid-column: 1 / -1;
    display: block;
  `;
});

const NoMeasurementsText = styled.h3`
  margin-bottom: 2rem;
`;

export interface IPlayerChartCards {
  measurements: {
    display_name: string;
    measurement_id: string;
    data: Chart[];
  }[];
  range: '';
  location: Location;
  rangeCallback: () => void;
  activeSessionCallback: (session: number) => void;
  activeSession: number;
}

const PlayerChartCards: FC<IPlayerChartCards> = ({
  measurements,
  range,
  rangeCallback,
  activeSessionCallback,
  activeSession,
}) => {
  const [measurementID, setMeasurementID] = useState<string | null>(null);
  const { id } = useParams<{ id: string }>();
  const location = useLocation();

  const clickHandler = (measurement_id: string) => {
    setMeasurementID(measurement_id);
  };

  return (
    <CardContainer>
      <Title>Activity progress</Title>

      <StyledDateToggle callback={rangeCallback} selected={range} />

      {measurements.length > 0 && (
        <Grid>
          {measurements.map((measurement_data) => (
            <PlayerChartCard
              key={`measurementChart-${measurement_data.measurement_id}`}
              measurementData={measurement_data}
              clickCallback={clickHandler}
            />
          ))}
        </Grid>
      )}

      {measurements.length <= 0 && (
        <NoMeasurements>
          {activeSession === 1 ? (
            <>
              <NoMeasurementsText>No records of your sessions found</NoMeasurementsText>
              <Button onClick={() => activeSessionCallback(0)}>View All Sessions</Button>
            </>
          ) : (
            <NoMeasurementsText>No sessions found</NoMeasurementsText>
          )}
        </NoMeasurements>
      )}

      {measurementID && (
        <Redirect
          push
          to={{
            pathname: `/player/${id}/dashboard/${measurementID}`,
            state: { from: location.pathname, activeSession },
            search: `?session=${activeSession}&range=${range}`,
          }}
        />
      )}
    </CardContainer>
  );
};

export default PlayerChartCards;
